'use client';

import { UserImpersonationModal } from '@/components/layout/UserImpersonationModal';
import { Button } from '@/components/ui/shadcn/button';
import { useState } from 'react';

interface ImitateButtonProps {
    isAdministrator: boolean;
    className?: string;
}

export function ImitateButton({ isAdministrator, className }: ImitateButtonProps) {
    const [modalOpen, setModalOpen] = useState(false);

    if (!isAdministrator) {
        return null;
    }

    return (
        <>
            <Button variant="default" size="sm" onClick={() => setModalOpen(true)} className={className}>
                Imitate
            </Button>
            <UserImpersonationModal open={modalOpen} onOpenChange={setModalOpen} />
        </>
    );
}
